(function (w, a) {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.components:mxList
	 * @module mx.components
	 *
	 * @description
	 * Visualizes list data.
	 *
	 * The following example shows hot to use mxList.
	 * mxList expects that vm.myList is an array of objects with 'title' and 'description' keys in following example.
	 * Like this: [{'title': 'My title', 'description': 'Some text'}, ... ]
	 * ```html
	 * <mx-list list="vm.myList"></mx-list>
	 * ```
	 *
	 * If you need to use other keys like  [{'name': 'My title', 'about': 'Some text'}, ... ],
	 * it can be done next way:
	 * ```html
	 * <mx-list list="vm.myList" title-key='name' description-key='about'></mx-list>
	 * ```
	 *
	 * An `on-item-click` attribute allows to set handler for item-click event.
	 * ```html
	 * <mx-list list="vm.myList" on-item-click="vm.handeItemClick(item)"></mx-list>
	 * ```
	 *
	 * Attribute `highlight-On-Click` responsible for on click behaviour. If set to true clicked item will be highlighted(true by default).
	 * ```html
	 * <mx-list list="vm.myList" on-item-click="vm.handeItemClick(item)"></mx-list>
	 * ```
	 *
	 * To make possible select items, it can be done next way:
	 * ```html
	 * <mx-list list="vm.myList" use-checkboxes="true" selected-items="vm.mySelectedItems"></mx-list>
	 * ```
	 * If 'vm.mySelectedItems' array contains some item-objects from 'vm.myList' array on start - the mxList will mark those items as selected on UI.
	 * And vice versa: When items are selected on UI, they will be added into 'vm.mySelectedItems' array.
	 *
	 *
	 * It's possible to set actions for each item with help "item-actions" attribute.
	 * Expected data format the same as for <mx-dropdown-menu /> component.
	 *
	 * To switch to virtual mode use:
	 * ```html
	 * <mx-list list="vm.myList" virtual="true"></mx-list>
	 * ```
	 * Full support for virtual mode will be provided upon virtual repeat fix (https://github.com/angular/material/issues/4169).
	 **/

	MxListCtrl.$inject = ['$scope', '$element'];

	function MxListCtrl($scope, $element) {
		var vm = this;
		var currentItem, list, columns, loading;

		vm.$onInit = function () {
			initScope();
			vm.resultList = [];
			vm._useCheckboxes = (vm.useCheckboxes || '').toLowerCase() === 'true';
			vm._allowPaging = (vm.allowPaging || '').toString().toLowerCase() === 'true';
			vm._highlightOnClick = (vm.highlightOnClick || 'true').toLowerCase() === 'true';
			vm._titleKey = vm.titleKey || 'title';
			vm._descriptionKey = vm.descriptionKey || 'description';
			vm._imageKey = vm.imageKey || 'image';
			vm.selectedItems = vm.selectedItems || [];
			vm._showItemActions = !!($element.attr('get-item-actions') || $element.attr('data-get-item-actions'));

			vm.tileRatio = vm.tileRatio || '1:1';
			vm.tileHeight = vm.tileHeight || '300px';
			vm.spaceBetween = vm.spaceBetween || '5px';
			vm.searchText = '';
			// Todo: should pass default paging behaviour via controller
			vm.paging = vm.paging || {
				page: +(vm.pageNumber || 0),
				count: vm.totalItems || (vm.list && vm.list.length) || 0,
				pageSize: +(vm.pageSize || 0),
				isLocalData: !vm.totalItems,
				callChanged: function () {
					vm.pageSize = vm.paging.pageSize;
					return setData();
				},
			};

			Object.defineProperty(vm, 'totalItems', {
				set: function (value) {
					vm.paging.count = value || 0;
					vm.paging.isLocalData = !value;
				},
			});

			vm.handleSelection = handleSelection;
			vm.handleItemClick = handleItemClick;
			vm.handleItemRightClick = handleItemRightClick;

			currentItem = null;
			a.forEach(vm.selectedItems, function (item) {
				item.__isSelected = true;
			});

			list = vm.list;
			Object.defineProperty(vm, 'list', {
				get: function () {
					return (list || []).filter(searchFilter(vm.searchText, vm.searchProperties));
				},
				set: function (value) {
					if (list !== value && Array.isArray(vm.selectedItems)) {
						list = value || [];

						// Todo: should suppress vm.paging call
						if (vm.paging.isLocalData && vm._allowPaging) {
							vm.paging.page = 1; // reset paging
							vm.paging.callLocalChanges(list.length);
						} else {
							setData();
						}
					}
				},
			});

			columns = { def: +(vm.columns || 5) };
			Object.defineProperty(vm, 'columns', {
				get: function () {
					return columns;
				},
				set: function (value) {
					columns.def = value;

					columns.lg = value;
					columns.md = columns.lg > 1 ? columns.lg - 1 : 1;
					columns.sm = columns.md > 1 ? columns.md - 1 : 1;
					columns.xs = columns.sm > 1 ? columns.sm - 1 : 1;
				},
			});

			// Todo: should hide inside data control component
			Object.defineProperty(vm, 'loading', {
				get: function () {
					return loading;
				},
				set: function (value) {
					loading = typeof value === 'string' ? value === 'true' : typeof value !== 'undefined' ? value : false;
					vm.paging.loading = loading;
				},
			});

			setData();
		};

		$scope.$watch('__$vm.searchText', function () {
			vm.paging.page = 1;
			setData();
		});

		return vm;

		function initScope() {
			if (vm.parentControllerAs) {
				$scope[vm.parentControllerAs] = getParent($scope, vm.parentControllerAs);
			} else {
				$scope.dataModel = $scope.$parent;
			}

			function getParent(scope, key) {
				return scope.$parent && (scope.$parent[key] || getParent(scope.$parent, key));
			}
		}

		function searchFilter(searchText, searchProperties) {
			const properties = typeof searchProperties === 'string' ? searchProperties.split(',').map((s) => s.trim()) : searchProperties;
			return (elem) => (searchText && searchText.length > 0 ? searchInProperties(elem, searchText, properties) : true);
		}

		function searchInProperties(obj, searchText, searchProperties) {
			let match = false;

			for (let prop in obj) {
				if (obj.hasOwnProperty(prop)) {
					const propValue = obj[prop];
					if (typeof propValue === 'string' && (!searchProperties || searchProperties.includes(prop)) && propValue.toLowerCase().includes(searchText.toLowerCase())) {
						match = true;
						break;
					} else if (typeof propValue === 'object') {
						match = searchInProperties(propValue, searchText, searchProperties);
						if (match) {
							break;
						}
					}
				}
			}
			return match;
		}

		function setData() {
			let pagingFilter = (elem) => elem;

			const filteredData = (vm.list || []).filter(searchFilter(vm.searchText, vm.searchProperties));

			if (vm.paging.isLocalData) {
				vm.paging.page = vm.paging.page > 0 ? vm.paging.page : vm.paging.page + 1;
				vm.paging.count = filteredData.length;

				const start = (vm.paging.page - 1) * vm.paging.pageSize;
				const end = start + vm.paging.pageSize || filteredData.length;

				// pass local filter
				pagingFilter = function (element, index) {
					return element && index >= start && index < end;
				};
			}
			vm.pageNumber = vm.paging.page - 1;

			var resultList = filteredData.filter(pagingFilter).map(mapListItem);

			// This trick is make to avoid 'mx-template-list' strange doubling rows when data changed
			vm.resultList = [];
			$scope.$evalAsync(function () {
				vm.resultList = resultList;
			});

			function mapListItem(item, i) {
				var mappedItem = {
					item: item,
					__visible: false,
					__highlighted: false,
				};

				item.__isSelected = item.__isSelected || false;

				item.__trackByKey = item.__trackByKey || i + Math.random();

				return mappedItem;
			}
		}

		function handleItemClick(e, listItem) {
			if (vm._highlightOnClick && !e.ctrlKey) {
				if (currentItem !== listItem) {
					if (currentItem) {
						currentItem.__highlighted = false;
					}
					currentItem = listItem;
					currentItem.__highlighted = true;
				}
			}

			if (e.ctrlKey) {
				if (currentItem) {
					currentItem.__highlighted = false;
				}
				listItem.__highlighted = false;

				listItem.item.__isSelected = !listItem.item.__isSelected;
				vm.handleSelection(listItem.item);
			} else {
				vm.onItemClick({ item: listItem.item });
			}
		}

		function handleItemRightClick(ev, item) {
			var rightClickHandler = vm.onItemRightClick({
				item: item,
			});
			if (rightClickHandler && rightClickHandler.then) {
				rightClickHandler.then(function (actions) {
					vm.dropdownEvent = ev;
					vm.menuItems = actions;
					vm.isDropdownOpen = true;
				});
			}
		}

		function handleSelection(item) {
			vm.selectionChanged({
				selectedItems: [item],
			});

			if (vm._useCheckboxes) {
				var index = vm.selectedItems.indexOf(item);
				if (index === -1) {
					vm.selectedItems.push(item);
				} else if (index > -1) {
					vm.selectedItems.splice(index, 1);
				}
			}
		}
	}

	var innerTemplate =
		'		<md-checkbox ' +
		'			aria-label="Check"' +
		'			ng-if="::__$vm._useCheckboxes" ' +
		'			ng-model="listItem.item.__isSelected" ' +
		'			ng-change="__$vm.handleSelection(listItem.item);" ' +
		'			ng-click="$event.stopPropagation();"> ' +
		'		</md-checkbox> ' +
		'		#ITEM-TEMPLATE# ' +
		'		<div ' +
		'			class="mx-list--actions" ' +
		'			ng-if="::__$vm._showItemActions">' +
		'			<mx-dropdown-menu' +
		'				load-items="__$vm.getItemActions({item: item})"' +
		'				icon="more_horiz"' +
		'				context="item">' +
		'			</mx-dropdown-menu>' +
		'		</div>';

	var dropdownMenu =
		'	<mx-dropdown-menu ' +
		'		hide-button="true" ' +
		'		ng-if="__$vm.menuItems.length" ' +
		'		items="__$vm.menuItems" ' +
		'		expanded="__$vm.isDropdownOpen" ' +
		'		event="__$vm.dropdownEvent" ></mx-dropdown-menu>';

	var _listFooterTpl =
		'' +
		'	<div class="mx-list-loading-indicator mx-loading-bg" ng-if="__$vm.loading" layout="row" layout-sm="column" layout-align="space-around"></div>' +
		'   <div class="mx-list-no-data" ng-if="__$vm.resultList.length === 0 && !__$vm.loading">' +
		"		{{'components.common.noData' | mxi18n }}" +
		'	</div> ' +
		'  <mx-workspace-common-paging-panel preprocessor="__$vm.paging" ng-if="__$vm._allowPaging" ng-show="__$vm.resultList.length">' +
		'  </mx-workspace-common-paging-panel>';

	var listTemplate = function (options) {
		options = options || {};
		return (
			'<div class="mx-list layout-column layout-align-center-center">' +
			dropdownMenu +
			'	<ul ng-if="!__$vm._virtual && !__$vm.loading && __$vm.resultList.length" role="list">' +
			'		<li role="listitem" ' +
			'			ng-class="{' +
			"'list-item_active' : listItem.__highlighted," +
			"'list-item_with-checkboxes' : __$vm._useCheckboxes," +
			"'list-item_selected' : listItem.item.__isSelected" +
			'					}"' +
			'			ng-repeat="listItem in __$vm.resultList track by listItem.item.__trackByKey" ' +
			(options.wholeItemClick ? '			ng-click="__$vm.handleItemClick($event, listItem)" ' : '') +
			'			mx-right-click="__$vm.handleItemRightClick($event, listItem.item)" ' +
			'			ng-init="item=listItem.item"' +
			'			aria-label="Click on item" ' +
			'			class="mx-list-item"> ' +
			innerTemplate +
			'		</li> ' +
			'	</ul>' +
			_listFooterTpl +
			'</div>'
		);
	};

	var componentOpts = {
		bindings: {
			list: '<',
			loading: '@',
			allowPaging: '<',
			searchText: '@',
			searchProperties: '@',
			pageNumber: '=?',
			pageSize: '=?',
			useCheckboxes: '@',
			paging: '<?',
			selectedItems: '<?',
			titleKey: '@',
			descriptionKey: '@',
			imageKey: '@',
			totalItems: '<?',
			highlightOnClick: '@',
			selectionChanged: '&',
			getItemActions: '&',
			virtual: '@',
			onItemClick: '&',
			onItemRightClick: '&',
			parentControllerAs: '@',
		},
		controller: MxListCtrl,
		controllerAs: '__$vm',
	};

	a.module('mx.components').component(
		'mxList',
		a.extend(a.copy(componentOpts), {
			template: function () {
				return listTemplate()
					.split('#ITEM-TEMPLATE#')
					.join(
						'<div class="md-list-item-text" ng-if="__$vm._virtual"> ' +
							'	<h3>{{ item[__$vm._titleKey] }}</h3> ' +
							'	<p>{{ item[__$vm._descriptionKey] }}</p> ' +
							'</div> ' +
							'<div class="md-list-item-text" ng-if="!__$vm._virtual"> ' +
							'	<h3>{{:: item[__$vm._titleKey] }}</h3> ' +
							'	<p>{{:: item[__$vm._descriptionKey] }}</p> ' +
							'</div> '
					);
			},
		})
	);

	var mxTemplateList = a.copy(componentOpts);
	a.module('mx.components').component(
		'mxTemplateList',
		a.extend(mxTemplateList, {
			transclude: true,
			template: [
				'$attrs',
				function ($attrs) {
					return listTemplate({
						wholeItemClick: !!$attrs.onItemClick,
					})
						.split('#ITEM-TEMPLATE#')
						.join(
							$attrs.templateId ? '<div class="md-list-item-text" ng-include src="__$vm.templateId"></div>' : '<div class="md-list-item-text" mx-transclude></div>'
						);
				},
			],
			bindings: a.extend(mxTemplateList.bindings, {
				templateId: '@',
				//loading: '@'
			}),
		})
	);

	// TODO: Move out `mxTiles` from `mx-list`.

	/**
	 * @ngdoc component
	 * @name mx.components:mxTiles
	 * @module mx.components
	 *
	 * @description
	 * Visualizes tiles data.
	 *
	 * The following example shows hot to use mxTiles.
	 * mxTiles expects that vm.myTiles is an array of objects with 'title', 'description' and 'image' keys in following example.
	 * Like this: [{'title': 'My title', 'description': 'Some text', 'image': 'http://...jpg'}, ... ]
	 * ```html
	 * <mx-tiles list="vm.myTiles"></mx-tiles>
	 * ```
	 *
	 * If you need to use other keys like [{'name': 'My title', 'about': 'Some text', 'icon': 'http://...gif'}, ... ],
	 * it can be done next way:
	 * ```html
	 * <mx-tiles
	 *    list="vm.myTiles"
	 *    image-key='icon'
	 *    title-key='name'
	 *    description-key='about'>
	 * </mx-tiles>
	 * ```
	 *
	 * To make possible select items, it can be done next way:
	 * ```html
	 * <mx-tiles list="vm.myTiles" use-checkboxes="true" selected-items="vm.mySelectedItems"></mx-tiles>
	 * ```
	 *
	 * An `on-item-click` attribute allows to set handler for item-click event.
	 * ```html
	 * <mx-tiles list="vm.myTiles" on-item-click="vm.handeItemClick(item)"></mx-tiles>
	 * ```
	 *
	 * If 'vm.mySelectedItems' array contains some item-objects from 'vm.myTiles' array on start - the mxTiles will mark those items as selected on UI.
	 * And vice versa: When items are selected on UI, they will be added into 'vm.mySelectedItems' array.
	 *
	 * It's possible to set actions for each item with help "item-actions" attribute.
	 * Expected data format the same as for <mx-dropdown-menu /> directive.
	 *
	 **/

	function getTileTemplate() {
		const elementId = 'mx-tiles-' + Math.round(Math.random() * 100000);
		return (
			'' +
			'<style> #' +
			elementId +
			' > .mx-tile {width: {{__$vm.tileWidth}}px; height: {{__$vm.tileHeight}}px; }</style>' +
			'<ul ' +
			'	id="' +
			elementId +
			'" ' +
			'	role="list" ' +
			'	class="mx-tile-wrapper" ' +
			'	md-cols="{{__$vm.columns.def}}" ' +
			'	ng-if="!__$vm._virtual && !__$vm.loading && __$vm.resultList.length"' +
			'	md-row-height="{{::__$vm.tileHeight}}" md-gutter="{{:: __$vm.spaceBetween}}">' +
			'	<li ' +
			'		key="{{__$vm.idKey ? item[__$vm.idKey] : \'\'}}"' +
			"		ng-class=\"{'mx-tile--active' : listItem.__highlighted,'mx-tile--selected' : listItem.item.__isSelected}\"" +
			'		ng-repeat="listItem in __$vm.resultList track by listItem.item.__trackByKey" ' +
			'		ng-click="__$vm.handleItemClick($event, listItem)" ' +
			'		ng-init="item=listItem.item"' +
			'		aria-label="Click on tile" ' +
			'		class="mx-tile" ' +
			'		role="listitem" ' +
			'		>' +
			'		<div class="mx-tile-content layout-column">' +
			'			#ITEM-TEMPLATE# ' +
			'		</div>' +
			'		<md-checkbox ' +
			'			class="mx-tile-checkbox" ' +
			'			aria-label="Check"' +
			'			ng-if="::__$vm._useCheckboxes" ' +
			'			ng-model="item.item.__isSelected" ' +
			'			ng-change="__$vm.handleSelection($event, item.item)" ' +
			'			ng-click="$event.stopPropagation()"> ' +
			'		</md-checkbox> ' +
			'	</li> ' +
			'</ul>' +
			_listFooterTpl +
			'</div>'
		);
	}

	var mxTiles = a.copy(componentOpts);
	a.module('mx.components').component(
		'mxTiles',
		a.extend(mxTiles, {
			template: getTileTemplate()
				.split('#ITEM-TEMPLATE#')
				.join(
					'<h5 class="mx-tile-title" title="{{:: item[__$vm._titleKey] }}">{{:: item[__$vm._titleKey] }}</h5> ' +
						'<div class="mx-tile-descr" title="{{:: item[__$vm._descriptionKey] }}">{{:: item[__$vm._descriptionKey] }}</div> '
				),
			bindings: a.extend(mxTiles.bindings, {
				columns: '<',
				spaceBetween: '@',
				tileRatio: '@',
				tileHeight: '@',
				tileWidth: '@',
				idKey: '@',
			}),
		})
	);

	var mxTemplateTiles = a.copy(componentOpts);
	a.module('mx.components').component(
		'mxTemplateTiles',
		a.extend(mxTemplateTiles, {
			transclude: true,
			template: [
				'$attrs',
				function ($attrs) {
					return getTileTemplate()
						.split('#ITEM-TEMPLATE#')
						.join($attrs.templateId ? '<div class="layout-row" ng-include src="__$vm.templateId"></div>' : '<div class="md-list-item-text" mx-transclude></div>');
				},
			],
			bindings: a.extend(mxTemplateTiles.bindings, {
				templateId: '@',
				columns: '<',
				spaceBetween: '@',
				tileRatio: '@',
				tileHeight: '@',
				tileWidth: '@',
				idKey: '@',
			}),
		})
	);
})(window, angular);
